module.exports = __webpack_public_path__ + "static/img/2.2457515.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/2.png
// module id = jklv
// module chunks = 0